class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.cartRefresh();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
    
    let cartItem = document.querySelectorAll(".cart-item");
     let freqarr=[];

      var freqpdt= document.querySelectorAll(".freq-parent");
      if (freqpdt.length === 0) return;
      freqpdt[0].style.display= "block";
      freqpdt.forEach(function (freqEle) {
        let freqhandle = freqEle.getAttribute("freqpdt");
        freqarr.push(freqhandle);

      cartItem.forEach( function (CartEle) {
        let carthandle = CartEle.getAttribute("handle");
        let hasItem = freqarr.includes(carthandle);
        if (hasItem == true){
          if (freqhandle == carthandle){
            freqEle.style.display= "none";
            freqarr.pop(freqhandle);
            if (freqarr.length === 0){
              let freqHeading = document.querySelector('.frequently_bought_heading h3');
              if (freqHeading) freqHeading.style.display= "none";
              let offerBlock = document.querySelector('.offer-block');
              if (offerBlock) offerBlock.style.display= "none";
            }
          }
        }
      });
    });
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    const drawerInner = this.querySelector('.drawer__inner');
    if (drawerInner && drawerInner.classList.contains('is-empty')) drawerInner.classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      const sectionHTML = parsedState.sections && parsedState.sections[section.id];
      if (!sectionElement || !sectionHTML) return;
      const updatedSection = this.getSectionDOM(sectionHTML, section.selector);
      if (updatedSection) sectionElement.innerHTML = updatedSection.innerHTML;
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
   cartRefresh(){
    const cartIcons = document.querySelectorAll('.header__icon--cart');
    var elem = this;
      cartIcons.forEach(icon => {
      icon.addEventListener('click', function() {
        fetch(window.location.pathname+`?section_id=cart-drawer`)
            .then((e) => e.text())
            .then((e) => {
                    const parsedHtml = new DOMParser().parseFromString(e, "text/html");
   let cartDrawerBody = parsedHtml.body.innerHTML;
              document.getElementById('CartDrawer').innerHTML = elem.getSectionInnerHTML(cartDrawerBody, '#CartDrawer');
              // Sync the empty/non-empty state from the freshly rendered section.
              // Without this, adding to an empty cart leaves the stale `is-empty`
              // class on <cart-drawer>, which hides the header and forces the
              // inner into a centered grid (blank-looking drawer).
              const refreshedDrawer = parsedHtml.querySelector('cart-drawer');
              if (refreshedDrawer) {
                elem.classList.toggle('is-empty', refreshedDrawer.classList.contains('is-empty'));
              }
            })
            .catch((e) => {
                console.error(e);
            });
                fetch(window.location.pathname+`?section_id=cart-icon-bubble`)
            .then((e) => e.text())
            .then((e) => {
                const parsedHtml = new DOMParser().parseFromString(e, "text/html");
    let cartIconBubbleBody = parsedHtml.body.innerHTML;
               document.getElementById('cart-icon-bubble').innerHTML = elem.getSectionInnerHTML(cartIconBubbleBody, '.shopify-section');
            })
            .catch((e) => {
                console.error(e);
            });
      });
  });
 }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
